import {initializeCalculatorStorage, initializePatientStorage} from '../stateHandler';
import {afterDomIsReady} from '../utils/whenLoaded';
import {getCheckedRadioByName} from '../utils/formFields';
import {assert} from '../utils/assert';
import {loadTemplate} from '../utils/loadTemplate';

export default () => afterDomIsReady(async () => {
	const templateEl = document.getElementById('poem-template') as HTMLTextAreaElement;
	assert(templateEl !== null);
	const getTemplate = await loadTemplate('./poem-template.html');
	const storage = initializeCalculatorStorage();

	const recount = () => {
		const currentState: {[key: string]: number|string} = {};
		let celkem = 0;
		let answeredCount = 0;

		for (let i = 1; i <= 7; i++) {
			const r = document.querySelector(`input[type=radio][name=r${i}]:checked`) as HTMLInputElement;
			if (r === null) {
				continue;
			}

			switch (r.value) {
				case 'kazdyden':
					celkem = celkem + 4;
					currentState[i] = 4;
					answeredCount++;
					break;
				case '56dnu':
					celkem = celkem + 3;
					currentState[i] = 3;
					answeredCount++;
					break;
				case '34dny':
					celkem = celkem + 2;
					currentState[i] = 2;
					answeredCount++;
					break;
				case '12dny':
					celkem = celkem + 1;
					currentState[i] = 1;
					answeredCount++;
					break;
				case 'anijedenden':
					currentState[i] = 0;
					answeredCount++;
					break;
			}
		}

		const scoreEl = document.getElementById('poem-score') as HTMLElement;
		const downloadButtonEl = document.getElementById('poem-downloadButton') as HTMLElement;
		const evaluationNoteEl = document.getElementById('poem-evaluationNote') as HTMLElement;

		if (answeredCount < 6) {
			scoreEl.innerText = '–';
			downloadButtonEl.setAttribute('hidden', 'hidden');
			evaluationNoteEl.removeAttribute('hidden');
			return;
		}

		const celkemAsString = celkem.toFixed(0);
		scoreEl.innerText = celkemAsString;
		downloadButtonEl.removeAttribute('hidden');
		evaluationNoteEl.setAttribute('hidden', 'hidden');
		currentState['celkem'] = celkemAsString;
		storage.update('poem', currentState);
	};

	// now
	recount();

	// and on every field change
	document.querySelectorAll('input[type=radio]').forEach(
		el => el.addEventListener('click', () => recount()));


	const resultEl = document.getElementById('poem-downloadForm');
	assert(resultEl !== null);
	resultEl.addEventListener('submit', () => {
		let template = getTemplate();

		const pacient = initializePatientStorage().get();
		template = template.replace('{titul}', pacient.degree || '');
		template = template.replace('{jmeno}', pacient.firstName || '');
		template = template.replace('{prijmeni}', pacient.lastName || '');
		template = template.replace('{datumVysetreni}', pacient.examinationDate || '');

		const state = storage.get('poem');
		for (let i = 1; i <= 7; i++) {
			template = template.replace(`{r${i}}`, typeof state[i] !== 'undefined' ? state[i] : '–');
		}
		template = template.replace('{celkem}', state.celkem);

		templateEl.value = template;
	});
});
